import NewLeadContainer from '../containers/NewLeadPage/NewLeadContainer';

export default function NewLead() {
    return <NewLeadContainer />;
}
